import EventTracking from "../../../../components/tracking/TrackingEvents";
import React from 'react';
import { useParams } from 'react-router-dom';

export default function ConsultEventsPage() {
    const { day, year, month } = useParams<{day:string, year:string, month:string}>();

    if (!day || !year || !month) return null;

    const monthInt = parseInt(month) - 1;

    return (
      <div>
       <EventTracking day={day} month={monthInt.toString()} year={year}/>
      </div>
    );
}
